import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEdit, FiTrash2, FiChevronUp, FiChevronDown } from 'react-icons/fi';
import axios from 'axios';
import { FaFileExcel } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { User } from 'react-feather'; // Import the User icon

// Styled components
const Container = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 3px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
      color:#293495;

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;
const Circle = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  // margin:14px 44px;
`;
const ProfileIcon = styled.div`
 width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;

const TableContainer = styled.div`
  overflow-x: auto;
  margin-top: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: linear-gradient(to bottom, #E6E6E6, #F2F2F2, #F5F5F5, #F3F3F3, #E9E9E9);
  box-shadow: 0px 10px 20px #0000001A;
  border-radius: 6px;
  opacity: 1;
`;

const TableHeader = styled.thead`
  background: linear-gradient(to bottom, #E6E6E6, #F2F2F2, #F5F5F5, #F3F3F3, #E9E9E9);
  color: #000;
`;

const TableRow = styled.tr``;

const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  white-space: nowrap;
  position: relative; /* Use relative positioning */
  cursor: pointer; /* Show that it's clickable */
  &:hover {
    color: #293495; /* Change color on hover */
  }

  /* Apply padding-right to make space for the sort icon */
  padding-right: 25px; 
`;

const SortIconContainer = styled.span`
  position: absolute;
  top: 57%;
  transform: translateY(-50%); /* Vertically center the icon */
  svg {
    font-size: 16px; /* Adjust the size of the icon */
    color: #000; /* Set the icon color */
  }
`;

const TableBody = styled.tbody``;

const TableCell = styled.td`
  padding: 10px;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
`;

// Pagination Styled Components

// Pagination Styled Components
const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;

const DropdownContainerTwo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;


  // &:hover {
  //   color: #293495;
  // }
`;

// Styling for the custom options panel
const OptionsPanel = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

// Individual option items
const OptionItem = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2b3497;
  margin: 0 5px;
`;


const ReceptionWorkloadReportPage = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [visitorData, setVisitorData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);
    const rowsPerPage = 7;

    const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });


    const renderSortIcon = (key) => {
        if (sortConfig.key === key) {
            return (
                <SortIconContainer>
                    {sortConfig.direction === 'ascending' ? <FiChevronUp style={{ fontSize: '18px', fontWeight: 'bold', color: '#000' }} /> : <FiChevronDown style={{ fontSize: '18px', fontWeight: 'bold', color: '#000' }} />}
                </SortIconContainer>
            );
        }
        return (
            <SortIconContainer>
                <FiChevronDown style={{ opacity: 0.3 }} /> {/* Default icon */}
            </SortIconContainer>
        );
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
        const sortedData = [...visitorData].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
            return 0;
        });
        setVisitorData(sortedData);
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        fetchVisitorTypeData();
    }, []);

    // useEffect(() => {
    //     setFilteredData(
    //         visitorData.filter((visitor) =>
    //                  visitor.checkInId?.toString().includes(searchTerm) ||
    //                 visitor.visitorName?.toLowerCase().includes(searchTerm) ||
    //                 visitor.visitorCompany?.toLowerCase().includes(searchTerm) ||
    //                 visitor.checkinType?.toLowerCase().includes(searchTerm) ||
    //                 visitor.isBlacklisted?.toString().includes(searchTerm) 
    //         )
    //     );
    // }, [searchTerm, visitorData]);

    const fetchVisitorTypeData = async () => {
        try {
            const response = await axios.get('/Report/GetReceptionWorkloadbyLocationReport');
            setVisitorData(response.data);
        } catch (error) {
            console.error('Error fetching Visitor Report data:', error);
        }
    };

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };
    const filteredData = visitorData.filter((visitor) => { 
        return (
            visitor.receptionistName && visitor.receptionistName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            visitor.location?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            visitor.visitsCreated?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            visitor.visitorsCreated?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            visitor.visitorPasses?.toString().includes(searchTerm.toLowerCase())
        );
    });

     useEffect(() => {
          setCurrentPage(1);
        }, [searchTerm]);

    const totalPages = Math.ceil(filteredData.length / rowsPerPage);
    const handlePageChange = (event) => {
        setCurrentPage(Number(event.target.value));
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };



    const currentRows = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );
    const renderPageNumbers = () => {
        const pageNumbers = [];
        const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

        let startPage = Math.max(currentPage - 5, 1);
        let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

        // Adjust startPage if endPage exceeds totalPages
        if (endPage === totalPages) {
            startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <PaginationButton
                    key={i}
                    className={currentPage === i ? 'active' : ''}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </PaginationButton>
            );
        }

        return pageNumbers;
    };
    const [isPanelOpen, setIsPanelOpen] = useState(false);

    // Function to toggle the export options panel
    const togglePanel = () => {
        setIsPanelOpen((prevState) => !prevState);
    };

    const handleExportOptionClick = (format) => {
        if (format === 'excel') {
            exportToExcel(); // Call the Excel export function
        } else if (format === 'pdf') {
            exportToPDF(); // Call the PDF export function
        }

        // Close the panel after making a selection
        setIsPanelOpen(false);
    };
    const exportToExcel = () => {
        const filteredDataNee = filteredData.map((row) => ({
            ReceptionistName: row.receptionistName,
            Location: row.location,
            VisitsCreated: row.visitsCreated,
            VisitorsCreated: row.visitorsCreated,
            VisitorsPasses: row.visitorPasses,

        }));

        // Create the worksheet with the filtered data
        const worksheet = XLSX.utils.json_to_sheet(filteredDataNee);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Reception workload Report');

        // Adjust column widths for better alignment (optional)
        worksheet['!cols'] = [
            { wpx: 100 }, // appointmentId
            { wpx: 150 }, // source
            { wpx: 150 }, // visitorName
            { wpx: 150 }, // visitorTypeDesc
            { wpx: 150 }, // visitorMobile

        ];


        XLSX.writeFile(workbook, 'Reception_workload_Report.xlsx');
    };

    const exportToPDF = () => {
        const doc = new jsPDF();
        doc.text('Reception workload  Reports', 14, 16);
        doc.autoTable({
            head: [
                ['Receptionist Name', 'Location', 'Visits Created', 'Visitors Created', 'Visitors Passes']
            ],
            body: filteredData.map((row) => [
                row.receptionistName,
                row.location,
                row.visitsCreated,
                row.visitorsCreated,
                row.visitorPasses,
            ]),
            startY: 30,
            theme: 'grid',
        });
        doc.save('Reception_workload_Report.pdf');
    };
    const [isExpanded, setIsExpanded] = useState(true);
    const toggleExpandCollapse = () => {
        setIsExpanded(!isExpanded);
    };


    return (
        <Container>
            <Header>
                <Heading>Reception Workload  Report (Last 7 Days)</Heading>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SearchBox>
                        <SearchIcon size={20} />
                        <SearchInput
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                    </SearchBox>
                    <DropdownContainerTwo>
                        <ExportIcon onClick={togglePanel} title="Export">
                            <FiDownload size={25} />
                        </ExportIcon>
                        {/* Show the panel with options if isPanelOpen is true */}
                        {isPanelOpen && (
                            <OptionsPanel>
                                <OptionItem onClick={() => handleExportOptionClick('excel')}>Excel</OptionItem>
                                <OptionItem onClick={() => handleExportOptionClick('pdf')}>PDF</OptionItem>
                            </OptionsPanel>
                        )}
                    </DropdownContainerTwo>
                </div>
            </Header>
            <TableContainer>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell colSpan={'8'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Reception Workload By Location Report</span>
                                    <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                                        {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                                    </IconWrapper>
                                </div>
                            </TableHeaderCell>

                        </TableRow>
                    </TableHeader>
                    {isExpanded && (
                        <>
                            <TableHeader>
                                <TableRow>
                                    <TableHeaderCell onClick={() => handleSort('receptionistName')}>Receptionist Name{renderSortIcon('receptionistName')}</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('location')}>Location{renderSortIcon('location')}</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('visitsCreated')}>Visits Created{renderSortIcon('visitsCreated')}</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('visitorsCreated')}>Visitors Created{renderSortIcon('visitorsCreated')}</TableHeaderCell>
                                    <TableHeaderCell onClick={() => handleSort('visitorPasses')}>Visitors Passes{renderSortIcon('visitorPasses')}</TableHeaderCell>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {currentRows.map((visitor, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{visitor.receptionistName}</TableCell>
                                        <TableCell>{visitor.location}</TableCell>
                                        <TableCell>{visitor.visitsCreated}</TableCell>
                                        <TableCell>{visitor.visitorsCreated}</TableCell>
                                        <TableCell>{visitor.visitorPasses}</TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </>)}
                </Table>
            </TableContainer>
            {isExpanded && (
                <>
                    <PaginationContainer>
                        <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                            Previous
                        </PaginationButton>

                        <DropdownSelect value={currentPage} onChange={handlePageChange}>
                            {Array.from({ length: totalPages }, (_, i) => (
                                <option key={i + 1} value={i + 1}>
                                    Page {i + 1}
                                </option>
                            ))}
                        </DropdownSelect>

                        <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                            Next
                        </PaginationButton>
                    </PaginationContainer>
                </>)}
        </Container>
    );
};

export default ReceptionWorkloadReportPage;
